import React from "react";

const AirConditioning = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="none"
    >
      <path
        d="M12.2002 3V9M12.2002 21V15M12.2002 12V9M12.2002 12V15M12.2002 12H9.2002M12.2002 12H16.2002M21.2002 12H16.2002M3.2002 12H9.2002M12.2002 9L16.2002 5M12.2002 9L8.2002 5M12.2002 15L16.2002 19M12.2002 15L8.2002 19M9.2002 12L5.2002 8M9.2002 12L5.2002 16M16.2002 12L19.2002 8M16.2002 12L19.2002 16"
        stroke="#00A3BC"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default AirConditioning;
